import React, { useCallback } from "react";
import { Card, CardContent, Grid } from "@mui/material";

const TabPanelWrapper = ({ components }) => {
 
  const componentsShape = useCallback(() => {
    const item = [];

    for (let component of components) {
      item.push(
        <Grid
          item
          md={component?.md ?? 12}
          lg={component?.lg ?? 12}
          xs={component?.xs ?? 12}
          xl={component?.xl ?? 12}
          sm={component?.sm ?? 12}
          sx={{ height: "100%" }}
        >
          {/* <Card
            sx={{
              boxShadow:
                "0 4px 8px 0 rgba(0,0,0,.2), 0 6px 20px 0 rgba(0,0,0,.19)",
              padding: "0px!important",
              borderRadius: ".25rem",
              height: "100%",
            }}
          >
            <CardContent
              style={{
                padding: "0.5rem",
                paddingBottom: "0.5rem",
              }}
            > */}
          {component?.component}
          {/* </CardContent>
          </Card> */}
        </Grid>
      );
    }
    return item;
  }, [components]);

  return (
    <>
      <Grid container style={{ height: "100%", width: "100%" }}>
        {componentsShape()}
      </Grid>
    </>
  );
};

export default TabPanelWrapper;
